<template>
  <div :class="['card', { 'card-clickable': clickable }]" @click="clickable && $emit('click', $event)">
    <slot></slot>
  </div>
</template>

<script setup>
defineProps({
  clickable: {
    type: Boolean,
    default: false
  }
})

defineEmits(['click'])
</script>

<style scoped>
/* Les styles .card et .card-clickable sont maintenant dans styles/cards.css */
/* Ce composant utilise les styles globaux */
</style>

